import React, { useEffect, useState } from "react";
import { Dropdown } from "react-bootstrap";

export default function MultipleRows({
  columnLabels,
  selectedRow,
  rowData,
  rowIndex,
  updateFunc,
}) {
  /*   All States
   ********************************************* */
  const [selectedColumnsList, setSelectedColumnsList] = useState([]);

  /*   All Functions
   ********************************************* */
  const UpdateRowDataByRowIndex = (value) => {
    const updatedRowData = [...rowData];
    updatedRowData[rowIndex] = value;
    updateFunc((prev) => updatedRowData);
  };

  const handleCheckboxChange = (label, index) => {
    // Create a unique identifier for checking
    const columnId = `${label}:${index}`;

    // Check if this column is already selected
    const isChecked = selectedColumnsList.some((item) => item.id === columnId);

    if (isChecked) {
      // Remove from selection
      setSelectedColumnsList((prev) =>
        prev.filter((item) => item.id !== columnId)
      );
    } else {
      // Add to selection with both name and index
      setSelectedColumnsList((prev) => [
        ...prev,
        { id: columnId, name: label, index },
      ]);
    }
  };

  const handleUpdate = () => {
    UpdateRowDataByRowIndex({
      ...selectedRow,
      rowValues: { ...selectedRow.rowValues, columns: selectedColumnsList },
    });
  };

  const getNamesFromColumnList = (list) => {
    if (!list || list.length === 0) return "";

    // Count occurrences of each name for display
    const nameCounts = {};
    list.forEach((item) => {
      if (!nameCounts[item.name]) {
        nameCounts[item.name] = 1;
      } else {
        nameCounts[item.name]++;
      }
    });

    // Format display string with counts for duplicates
    return Object.entries(nameCounts)
      .map(([name, count]) => (count > 1 ? `${name} (${count})` : name))
      .join(", ");
  };

  /*   All UseEffects
   ********************************************* */
  // Initialize from props
  useEffect(() => {
    if (selectedRow?.rowValues?.columns) {
      // Handle both new format (objects) and old format (strings)
      const columns = selectedRow.rowValues.columns.map((col) => {
        if (typeof col === "string") {
          // Convert old format to new format
          const index = columnLabels.findIndex((label) => label === col);
          return {
            id: `${col}:${index}`,
            name: col,
            index: index >= 0 ? index : undefined,
          };
        }
        return col; // Already in new format
      });

      setSelectedColumnsList(columns);
    } else {
      setSelectedColumnsList([]);
    }
  }, [selectedRow, columnLabels]);

  // Helper to check if a column name appears multiple times
  const isDuplicateColumn = (name) => {
    return columnLabels.filter((label) => label === name).length > 1;
  };

  // Helper to get context for duplicate columns
  const getColumnContext = (index) => {
    // Look for nearby header to provide context
    for (let i = 1; i <= 3; i++) {
      if (
        index - i >= 0 &&
        columnLabels[index - i] !== columnLabels[index] &&
        !["S", "M", "L", "XL", "XXL", "Total"].includes(columnLabels[index - i])
      ) {
        return `(${columnLabels[index - i]})`;
      }
    }
    return `(col ${index + 1})`;
  };

  return (
    <div className="row mb-2 ">
      <div className="col-md-3 px-1 mx-0 d-flex align-items-center">
        <input
          type="checkbox"
          name="hideHeader"
          className=" h-50 w-50 "
          checked={selectedRow?.rowValues?.hideHeader || false}
          onChange={(e) => {
            const isChecked = e.target.checked;
            UpdateRowDataByRowIndex({
              ...selectedRow,
              rowValues: { ...selectedRow.rowValues, hideHeader: isChecked },
            });
          }}
        />
        <label className="text-nowrap">Hide Header</label>
      </div>
      <div className="col-md-5 px-1 mx-0">
        <input
          type="text"
          name="customHeader"
          placeholder="Custom Header"
          className="form-control form-control-sm"
          value={selectedRow?.rowValues?.customHeader || ""}
          onChange={(e) => {
            const newValue = e.target.value;
            UpdateRowDataByRowIndex({
              ...selectedRow,
              rowValues: { ...selectedRow.rowValues, customHeader: newValue },
            });
          }}
        />
      </div>
      <div className="col-md-4 px-1 mx-0">
        <Dropdown>
          <Dropdown.Toggle className="btn-sm px-1 w-100 overflow-hidden text-truncate">
            {selectedColumnsList.length
              ? getNamesFromColumnList(selectedColumnsList)
              : "Select Columns"}
          </Dropdown.Toggle>
          <Dropdown.Menu className="w-100 bg-light shadow-sm">
            <div style={{ height: 300, overflowY: "auto" }}>
              {columnLabels.map((label, index) => {
                const columnId = `${label}:${index}`;
                const isSelected = selectedColumnsList.some(
                  (item) => item.id === columnId
                );

                return (
                  <div
                    onClick={() => {
                      handleCheckboxChange(label, index);
                    }}
                    className="bg-white d-flex align-items-center shadow-sm mb-1 mx-1 px-3 py-2"
                    key={index}
                    style={{ cursor: "pointer" }}
                  >
                    <input
                      type="checkbox"
                      name={label}
                      onChange={() => {}}
                      className="me-2"
                      checked={isSelected}
                    />
                    <label className="text-nowrap overflow-hidden text-truncate">
                      {label}
                      {/* Show context for duplicate columns */}
                      {isDuplicateColumn(label) && (
                        <small className="text-muted ms-1">
                          {getColumnContext(index)}
                        </small>
                      )}
                    </label>
                  </div>
                );
              })}
            </div>
            <Dropdown.Item className="mt-1 px-1">
              <button
                onClick={handleUpdate}
                className="btn btn-sm btn-success w-100"
              >
                Update
              </button>
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </div>
    </div>
  );
}
